import { Typography, Button } from "@ann/web-components";
import { AccessOptionsBar, AccessOptionsBarLeft, AccessOptionsBarRight } from "../DrivesView.styled";

const AccessOptionsHeader = ({ selectMode, setSelectMode, selectedItems, setIsOpen, totalSources, totalSelected, clearSelections }) => {

    const handleCancel = () => {
        setSelectMode(false);
        clearSelections();
    }

    return (
        <AccessOptionsBar>
            <AccessOptionsBarLeft>
                {selectMode ? (
                    <>
                        <Button
                            label="Remove Access"
                            size="medium"
                            type="secondary"
                            disabled={selectedItems.length === 0}
                            onClick={() => setIsOpen(true)}
                        />
                        <Button
                            label="Cancel"
                            size="medium"
                            type="secondary"
                            onClick={handleCancel}
                        />
                    </>
                ) : (
                    <Button
                        label="Select"
                        size="medium"
                        type="secondary"
                        onClick={() => setSelectMode(true)}
                    />
                )}
            </AccessOptionsBarLeft>
            <AccessOptionsBarRight>
                <Typography
                    category="body"
                    size="medium"
                    weight="regular"
                    color="body"
                >
                    {selectMode ? `${totalSelected} / ${totalSources} Data Sources` : `${totalSources} Data Sources`}
                </Typography>
            </AccessOptionsBarRight>
        </AccessOptionsBar>
    );
};

export default AccessOptionsHeader;
